import React, { createContext, useContext } from 'react';
import type { ComponentType, ReactNode } from 'react';

/**
 * ui-x is shared across three apps with three different routers (react-router,
 * Next.js, TanStack). Components inside ui-x never import a router directly —
 * they render <UIXLink>, and each app installs its own link component once at
 * the root via <LinkProvider>.
 */
export type UIXLinkProps = {
  to: string;
  className?: string;
  children?: ReactNode;
  target?: string;
  rel?: string;
  onClick?: () => void;
};

const AnchorLink: ComponentType<UIXLinkProps> = ({ to, children, ...rest }) => (
  <a href={to} {...rest}>
    {children}
  </a>
);

const LinkContext = createContext<ComponentType<UIXLinkProps>>(AnchorLink);

export function LinkProvider({
  component,
  children,
}: {
  component: ComponentType<UIXLinkProps>;
  children: ReactNode;
}) {
  return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}

export function useLinkComponent() {
  return useContext(LinkContext);
}

export function UIXLink(props: UIXLinkProps) {
  const Component = useLinkComponent();
  return <Component {...props} />;
}
